import React from 'react';
import { motion } from 'framer-motion';
import { Card } from '../utils/stones';
import { Stone } from './Stone';
interface GameCardProps {
  card: Card;
  index: number;
}
export function GameCard({
  card,
  index
}: GameCardProps) {
  const count = card.stones.length;
  return <motion.div layout initial={{
    opacity: 0,
    y: 16,
    scale: 0.96
  }} animate={{
    opacity: 1,
    y: 0,
    scale: 1
  }} transition={{
    duration: 0.35,
    delay: index * 0.04,
    ease: 'easeOut'
  }} className="relative aspect-[3/4] rounded-2xl bg-white shadow-[0_2px_10px_rgba(0,0,0,0.08)] ring-1 ring-slate-200 overflow-hidden" data-id="element-13">
      {/* Card top index badge */}
      <span className="absolute left-2 top-2 text-[10px] font-bold text-slate-400" data-id="element-14">
        {count}
      </span>
      <span className="absolute right-2 bottom-2 rotate-180 text-[10px] font-bold text-slate-400" data-id="element-15">
        {count}
      </span>

      <div className="flex h-full flex-col items-center justify-center gap-3 p-3" data-id="element-16">
        {card.stones.map(stone => <Stone key={stone.id} shape={stone.shape} color={stone.color} data-id="element-17" />)}
      </div>
    </motion.div>;
}